import Vue from 'vue'
import { getStorage, setStorage } from './tools'
import { USER_IS_VIP_STORE_KEY } from './constant'

export const appState = Vue.observable({
  userData: {
    is_vip: +getStorage(USER_IS_VIP_STORE_KEY) || 0,
  },
  isShowDiscountPopup: false,
})

export const setAppUserData = (userData = {}) => {
  appState.userData = {
    ...appState.userData,
    ...(userData || {}),
  }

  if (Object.prototype.hasOwnProperty.call(userData || {}, 'is_vip')) {
    setStorage(USER_IS_VIP_STORE_KEY, userData.is_vip)
  }
}

export const setIsShowDiscountPopup = (value) => {
  appState.isShowDiscountPopup = !!value
}

export const setAppUserDetail = (detail = {}) => {
  if (detail.user_info) {
    setAppUserData(detail.user_info)
  }

  if (Object.prototype.hasOwnProperty.call(detail, 'is_show_discount_popup')) {
    setIsShowDiscountPopup(detail.is_show_discount_popup)
  }
}
